import { Icon } from "@chakra-ui/react";
import React from "react";

export const TestsIcon = (props: any) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.293 2.70703L14.111 3.52503L3.318 14.318C2.468 15.168 2 16.298 2 17.5C2 18.702 2.468 19.832 3.318 20.683C4.169 21.532 5.299 22 6.5 22C7.701 22 8.831 21.532 9.682 20.682L20.475 9.88903L21.293 10.707L22.707 9.29303L14.707 1.29303L13.293 2.70703ZM16.475 11.061L14.072 8.65703L12.658 10.071L15.061 12.475L13.647 13.89L12.657 12.9L11.243 14.314L12.233 15.304L10.818 16.719L8.415 14.315L7 15.728L9.403 18.132L8.267 19.268C7.322 20.212 5.677 20.212 4.732 19.268C4.26 18.795 4 18.168 4 17.5C4 16.832 4.26 16.205 4.732 15.732L15.525 4.93903L19.06 8.47403L16.475 11.061Z"
      // fill="#07092F"
      fill="currentColor"
    />
  </Icon>
);
